import React from "react";
import "./FeaturedCaseStudies.css";
import { Link } from "react-router-dom";
import { Button } from "./Button";
import { CASE_STUDIES } from "../data/CaseStudiesData";

export default function FeaturedCaseStudies({ max = 3 }) {
  const items = CASE_STUDIES.slice(0, max);
  return (
    <section className="fc-wrap">
      <header className="fc-head">
        <h2>Featured Case Studies</h2>
        <p>Deep-dive stories showing goals, media strategy, and real outcomes.</p>
      </header>

      <div className="fc-grid">
        {items.map(cs => (
          <article key={cs.id} className="fc-card">
            <div className="fc-thumb">
              <img src={cs.cover} alt={cs.title} loading="lazy" />
            </div>
            <div className="fc-meta">
              <h3>{cs.title}</h3>
              <ul className="fc-bullets">
                <li><strong>Goals: </strong>{cs.goals[0]}</li>
                <li><strong>Results: </strong>{cs.results[0]}</li>
                <li><strong>Tech: </strong>{cs.tech.slice(0,2).join(" · ")}…</li>
              </ul>
              <div className="fc-actions">
                <Link to={cs.slug}>
                  <Button className="btn-mobile" buttonStyle="btn--primary" buttonSize="btn--medium">
                    View Study
                  </Button>
                </Link>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
